import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private readonly PREFIX = 'metasmile_';

  async setItem(key: string, value: any): Promise<void> {
    try {
      const serializedValue = JSON.stringify(value);
      // UTF-8 safe base64 encoding
      const encoded = btoa(encodeURIComponent(serializedValue).replace(/%([0-9A-F]{2})/g,
        (match, p1) => String.fromCharCode(parseInt(p1, 16))));
      
      await Preferences.set({
        key: this.PREFIX + key,
        value: encoded
      });
    } catch (e) {
      console.error('Error saving to storage', e);
    }
  }

  async getItem<T>(key: string): Promise<T | null> {
    try {
      const { value } = await Preferences.get({ key: this.PREFIX + key });
      if (!value) return null;
      
      // UTF-8 safe base64 decoding
      const decoded = decodeURIComponent(atob(value).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      
      return JSON.parse(decoded) as T;
    } catch (e) {
      console.error('Error reading from storage', e);
      return null;
    }
  }

  async removeItem(key: string): Promise<void> {
    await Preferences.remove({ key: this.PREFIX + key });
  }

  async clear(): Promise<void> {
    // Note: We might want to only clear our prefixed keys if possible, 
    // but standard clear() wipes everything. For better safety we'll use clear() 
    // if we intend a full signout.
    await Preferences.clear();
  }
}
